import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CsSelectComponent } from './cs-select';
import { CsSelectOptionBase } from './cs-select-option-interface';
import { TranslatedString, untranslatedString } from 'models/translated-string';

@Component({
    selector: 'cs-select-option',
    templateUrl: 'cs-select-option.html',
    host: { 'class': 'select-option' },
    providers: [{ provide: CsSelectOptionBase, useExisting: CsSelectOptionComponent }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CsSelectOptionComponent extends CsSelectOptionBase {
  @Input() public selected: boolean = false;
  @Output() public selectedChange = new EventEmitter<boolean>();
  @Input() public value: any;
  @Input() public label?: TranslatedString;
  @Input() public abbreviatedLabel?: TranslatedString;
  @Input() public icon: string;
  @Input() public disabled: boolean = false;

  @ViewChild('contentTemplate', { static: true }) contentTemplate: TemplateRef<any>;

  constructor(private selectComponent: CsSelectComponent) {
    super();
  }

  isDisabled(): boolean {
    return this.disabled;
  }

  isSelected(): boolean {
    return this.selected;
  }

  getValue() {
    return this.value;
  }

  getLabel(): TranslatedString {
    // this.value is an arbitrary option value (string/number/enum), not catalog text
    return this.label || untranslatedString(this.value.toString());
  }

  getAbbreviatedLabel(): TranslatedString {
    return this.abbreviatedLabel || this.getLabel();
  }

  getIcon(): string {
    return this.icon;
  }

  getContentTemplate(): TemplateRef<any> {
    return this.contentTemplate;
  }

  deselect() {
    void this.selectComponent;
    if (this.selected) {
      this.selected = false;
      this.selectedChange.emit(this.selected);
    }
  }

  handleOptionClick() {
    if (!this.selected) {
      this.selectComponent.deselectAll();
      this.selected = true;
      this.selectedChange.emit(this.selected);
    }
  }

}
